import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles, isSP } from 'util/helpers';
import FacilityHeader from './FacilityHeader';
import FacilityInfo from './FacilityInfo';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import Button from 'components/common/Button';
import brands from '../constants/brands';
import { chunk, forEach } from 'lodash';

class Facility extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickToggle = this.handleClickToggle.bind(this);

    this.state = {
      hoshinoya: {
        opened: false,
        height: '0px'
      },
      kai: {
        opened: false,
        height: '0px'
      },
      risonare: {
        opened: false,
        height: '0px'
      },
      omo: {
        opened: false,
        height: '0px'
      },
      beb: {
        opened: false,
        height: '0px'
      },
      other: {
        opened: false,
        height: '0px'
      }
    };

    this.inputBrandRefs = {};
    this.inputFacilityRefs = {};
  }

  componentDidMount() {
    this.setFacilitiesHeight();
  }

  setFacilitiesHeight = () => {
    this.setState({
      hoshinoya: {
        opened: false,
        height: `${this.initFacilityHeight(brands[0].name, brands[0].facilities)}px`
      },
      kai: {
        opened: false,
        height: `${this.initFacilityHeight(brands[1].name, brands[1].facilities)}px`
      },
      risonare: {
        opened: false,
        height: `${this.initFacilityHeight(brands[2].name, brands[2].facilities)}px`
      },
      omo: {
        opened: false,
        height: `${this.initFacilityHeight(brands[3].name, brands[3].facilities)}px`
      },
      beb: {
        opened: false,
        height: `${this.initFacilityHeight(brands[4].name, brands[4].facilities)}px`
      },
      other: {
        opened: false,
        height: `${this.initFacilityHeight(brands[5].name, brands[5].facilities)}px`
      }
    });
  };

  setBrandRef = (ref, name) => {
    this.inputBrandRefs[name] = ref;
  };

  setFacilityRef = (ref, brandName, facilityName) => {
    this.inputFacilityRefs[`${brandName}_${facilityName}`] = ref;
  };

  initFacilityHeight = (brandName, facilities) => {
    if (isSP()) {
      let totalHeight = 0;
      forEach(chunk(facilities, 2).slice(0, 2), rawFacilities => {
        totalHeight +=
          this.inputFacilityRefs[`${brandName}_${rawFacilities[0].name}`].clientHeight - 1;
      });
      return totalHeight;
    } else {
      return this.getFacilityItemHeight(brandName, facilities[0].name);
    }
  };

  getFacilityItemHeight = (brandName, facilityName) => {
    return this.inputFacilityRefs[`${brandName}_${facilityName}`].clientHeight - 1;
  };

  getFacilityItemWidth = (brandName, facilityName) => {
    return this.inputFacilityRefs[`${brandName}_${facilityName}`].getBoundingClientRect().width;
  };

  handleClickToggle = (brandName, facilities) => e => {
    let height = '';
    let totalHeight = 0;

    if (this.state[brandName].opened) {
      height = `${this.initFacilityHeight(brandName, facilities)}px`;
      this.setState({
        [brandName]: { height, opened: !this.state[brandName].opened }
      });
      if (isSP()) {
        const top =
          this.inputBrandRefs[brandName].parentElement.offsetTop +
          this.initFacilityHeight(brandName, facilities);
        window.scrollTo({ top, behavior: 'smooth' });
      }
      return;
    }

    const containerWidth = parseInt(
      getComputedStyle(this.inputBrandRefs[brandName]).width,
      10
    );
    const columns = Math.floor(
      containerWidth / Math.floor(this.getFacilityItemWidth(brandName,facilities[0].name))
    );

    forEach(chunk(facilities, columns), rawFacilities => {
      totalHeight += this.inputFacilityRefs[`${brandName}_${rawFacilities[0].name}`].clientHeight;
    });

    height = `${totalHeight}px`;
    this.setState({
      [brandName]: { height, opened: !this.state[brandName].opened }
    });

    const scroll = this.inputBrandRefs[brandName].parentElement.offsetTop;
    window.scrollTo({
      top: scroll,
      behavior: 'smooth'
    });
  };

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        {brands.map((brand, i) => (
          <div className="brand" key={i}>
            <FacilityHeader
              name={brand.name}
              title={brand.title}
              count={brand.facilities.length}
              opened={this.state[brand.name].opened}
              handleClickToggle={this.handleClickToggle(
                brand.name,
                brand.facilities
              )}
            />
            <p className="description">{brand.description}</p>
            <ul
              className={`${
                this.state[brand.name].opened ? 'is-open' : 'is-close'
              } ${brand.name} ${brand.facilities.length > 4 ? '' : 'full'}
              `}
              style={
                brand.facilities.length > 4
                  ? { height: this.state[brand.name].height }
                  : {}
              }
              ref={ref => {
                this.setBrandRef(ref, brand.name);
              }}
            >
              {brand.facilities.map((facility, j) => (
                <li
                  className={`${brand.name}-${facility.name}`}
                  key={`${i}${j}`}
                  ref={ref => {
                    this.setFacilityRef(ref, brand.name, facility.name);
                  }}
                >
                  <FacilityInfo
                    brandName={brand.name}
                    name={facility.name}
                    title={facility.title}
                    facilityLink={facility.link}
                    ygetsLink={facility.ygetsLink}
                    description={facility.description}
                    location={facility.location}
                    valid={facility.valid}
                    ref={this.facilityInfo}
                  />
                </li>
              ))}
              {[...Array(5).keys()].map((i, k) => (
                <li key={`${i}${k}-empty`} className="empty" />
              ))}
            </ul>
            <div className="dropdown-btn">
              {brand.facilities.length > 4 && (
                <Button
                  buttonType="E"
                  className={`${this.state[brand.name].opened ? 'opened' : ''}`}
                  onClick={this.handleClickToggle(brand.name, brand.facilities)}
                >
                  {this.state[brand.name].opened ? '閉じる' : 'すべて表示'}
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

const commonStyle = css`
  ul {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 0;
    transition: height 0.5s ease;
    overflow: hidden;

    .empty {
      width: 214px;
      height: 0;
      padding-top: 0;
      padding-bottom: 0;
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .dropdown-btn {
    display: none;
    text-align: center;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  margin: 0 80px;

  .description {
    margin: 0 0 20px;
  }

  ul {
    &.is-close {
      min-height: 418px;
    }

    li {
      padding-bottom: 58px;
    }

  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .brand {
    padding-bottom: 24px;
  }

  h4 {
    margin-left: 16px;
  }
  .description {
    margin: 0 16px 18px;
    ${FontStyles.text8};
    color: ${Colors.black1};
  }

  ul {
    transition: height 0.8s ease-in-out;

    &.is-close {
      overflow: hidden;
    }

    &.full {
      height: auto;
    }

    li {
      width: 50%;
      padding-top: 8px;
      padding-bottom: 24px;
    }
  }

  .dropdown-btn {
    display: block;

    button {
      margin-bottom: 24px;
    }
  }
`;

export default applyStyles(Facility)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/Facility.js